import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/formsDashboard')({
  loader() {
    throw redirect({ to: '/projectResources', search: { projectResourceTab: 'formsDashboard' } });
  },
});
